module.exports = __webpack_public_path__ + "assets/img/h3.26370898.jpg";